import {
    Platform
} from "react-native";

const SUPPRESS_TRANSITIONS_CSS = "*, *::before, *::after { transition: none !important; }";

let suppressStyle: HTMLStyleElement | undefined;

let suppressFrame = 0;

const handleRelease = () => {
    suppressStyle?.remove();

    suppressStyle = undefined;
};

const suppressWebTransitions = () => {
    if(Platform.OS !== "web" || typeof document === "undefined" || !document.head) {
        return;
    }

    if(!suppressStyle) {
        suppressStyle = document.createElement("style");

        suppressStyle.append(document.createTextNode(SUPPRESS_TRANSITIONS_CSS));

        document.head.append(suppressStyle);
    }

    document.body?.getBoundingClientRect();

    cancelAnimationFrame(suppressFrame);

    suppressFrame = requestAnimationFrame(() => {
        suppressFrame = requestAnimationFrame(handleRelease);
    });
};
export default suppressWebTransitions;
